module.exports = __webpack_public_path__ + "img/btnn-start.6a8b88e7.png";